<template>
    <app-layout title="Bestekken">
        <template #header>
            <page-title :title="'Bestek ' + estimate.name" />
        </template>

        <template #pageContent>
            <Button
                htmlType="a"
                buttonClass="edit"
                text="Bestek bewerken"
                :href="route('estimates.edit', { 'estimate': estimate.id })"
            />
            <Button
                buttonClass="cancel"
                text="Deactiveren"
                @click="deactivateEstimate"
                v-if="Boolean(estimate.active)"
            />
            <Button
                buttonClass="success"
                text="Activeren"
                @click="activateEstimate"
                v-if="!Boolean(estimate.active)"
            />

            <div class="mt-2">
                Naam: {{ estimate.name }}<br>
                Status: <i class="fas fa-exclamation-triangle text-orange-500"  v-if="estimate.active == 0"></i> {{ (estimate.active == 1) ? 'Actief' : 'Inactief' }}
            </div>
            <h3 class="mt-4">Duedates</h3>
            <Table :id="'estimate-detail-estimate-duedates-' + estimate.id" :values="estimate.estimate_duedates" class="w-1/2 mb-4">
                <thead>
                    <tr>
                        <Th id="assignment_type.name">Opdracht</Th>
                        <Th id="urgent">Urgent</Th>
                        <Th id="non_urgent">Niet urgent</Th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="estimateDuedate in state.sortedValues['estimate-detail-estimate-duedates-' + estimate.id]" :key="estimateDuedate.id">
                        <Td>{{ estimateDuedate.assignment_type.name }}</Td>
                        <Td>{{ estimateDuedate.urgent }}</Td>
                        <Td>{{ estimateDuedate.non_urgent }}</Td>
                    </tr>
                </tbody>
            </Table>
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'
import Table from '@/Components/Table.vue'
import Th from '@/Components/Th.vue'
import Td from '@/Components/Td.vue'
import Button from '@/Components/Button.vue'

import store from '@/store'
import {Inertia} from "@inertiajs/inertia";

export default {
    components: {
        AppLayout,
        PageTitle,
        Button,
        Table,
        Td,
        Th,
    },
    props: [
        'estimate',
    ],
    setup (props)
    {
        function deactivateEstimate()
        {
            if (!confirm('Bent u zeker dat u dit bestek wil deactiveren?'))
                return

            Inertia.post(route('estimates.deactivate', { 'estimate': props.estimate.id }))
        }

        function activateEstimate()
        {
            Inertia.post(route('estimates.activate', { 'estimate': props.estimate.id }))
        }

        return {
            state: store.state,
            ...store,
            deactivateEstimate,
            activateEstimate,
        }
    },
}

</script>
